import { useMutation, InjectedOptions } from "@oysterhr/core"
import { gql } from "@apollo/client"
import { UpdatePayrollEntityInput, UpdatePayrollEntityPayload } from "@oysterhr/schema"

export const PAYROLL_ENTITY_STAFF_UPDATE = gql`
  mutation UpdatePayrollEntity(
    $name: String
    $notes: String
    $position: Int
    $companyId: ID
    $cutOffMonthDay: Int
    $employerOfRecordId: String!
    $externalToolsAttributes: [ExternalToolInputType!]
    $employerOfRecordCountryId: String
    $employerOfRecordCountryByAlpha2: String
    $employerOfRecordDetailAttributes: EmployerOfRecordDetailsAttributesInput
  ) {
    updatePayrollEntity(
      input: {
        name: $name
        notes: $notes
        position: $position
        companyId: $companyId
        cutOffMonthDay: $cutOffMonthDay
        employerOfRecordId: $employerOfRecordId
        externalToolsAttributes: $externalToolsAttributes
        employerOfRecordCountryId: $employerOfRecordCountryId
        employerOfRecordCountryByAlpha2: $employerOfRecordCountryByAlpha2
        employerOfRecordDetailAttributes: $employerOfRecordDetailAttributes
      }
    ) {
      errors
      employerOfRecord {
        id
        name
        position
        employerOfRecordCountry {
          alpha2
        }
        details {
          extraFee
          contactEmails
        }
      }
    }
  }
`

export type UpdatePayrollEntityPayloadType = {
  updatePayrollEntity: UpdatePayrollEntityPayload
}

export const useUpdatePayrollEntity = (
  options?: InjectedOptions<UpdatePayrollEntityPayloadType, UpdatePayrollEntityInput>,
) =>
  useMutation<UpdatePayrollEntityPayloadType, UpdatePayrollEntityInput>(
    PAYROLL_ENTITY_STAFF_UPDATE,
    options,
  )
